export const analytics = {
  triggerAnalytics: (storeId) => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-pod.select-store', {});
      window.LIFE_CYCLE_EVENT_BUS.trigger('header-store-pod.select-store-click', { storeId });
    }
  }
};
